import { StandaloneTrendingMenu } from 'base/components/TrendingMenu';
import OLWBanner from './OLWBanner';

export const HantStandaloneTrendingMenu: typeof StandaloneTrendingMenu = (props) => {
  return (
    <>
      <StandaloneTrendingMenu {...props} />
      <OLWBanner />
    </>
  );
};
